import React from "react";
import NotificationList from "./NotificationList";
import { FleetrifyDrawer } from "../Drawer/drawer";

interface NotificationDrawerProps {
  isOpen: boolean;
  setIsOpen: (param: boolean) => void;
  isLoading: boolean;
  notificationsData: any[];
  handleDismiss: (notificationId: string) => void;
  handleMarkAsRead: (notificationId: string) => void;
  // Opens what the notification is about (only set for linkable types).
  handleOpen?: (notification: any) => void;
}

const NotificationDrawer: React.FC<NotificationDrawerProps> = ({
  isOpen,
  setIsOpen,
  isLoading,
  notificationsData,
  handleDismiss,
  handleMarkAsRead,
  handleOpen,
}) => {
  return (
    <FleetrifyDrawer
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      title="Notifications"
    >
      <NotificationList
        isLoading={isLoading}
        notificationsData={notificationsData}
        handleDismiss={handleDismiss}
        handleMarkAsRead={handleMarkAsRead}
        handleOpen={handleOpen}
      />
    </FleetrifyDrawer>
  );
};

export default NotificationDrawer;
